import { render, staticRenderFns } from "./CategorySelect.vue?vue&type=template&id=1722b71e&scoped=true&"
import script from "./CategorySelect.vue?vue&type=script&lang=ts&"
export * from "./CategorySelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1722b71e",
  null
  
)

export default component.exports